export default "__VITE_ASSET__DNOXu__P__"